import { TSpendingLimitType } from '../../../hooks/useGetSpendingLimits';

export function formatDuration({
  duration,
  groupSameLimits = true,
}: {
  duration: number;
  groupSameLimits?: boolean;
}) {
  if (groupSameLimits && (duration === 1 || duration === 3)) {
    return '30 day / 3 month';
  }

  if (duration === 1) {
    return '30 day';
  }

  return `${duration} month`;
}

const SELLER_PRODUCT_TO_DURATION_IN_MONTHS: Record<TSpendingLimitType, number> =
  {
    THIRTY_DAYS: 1,
    THREE_MONTHS: 3,
    TWELVE_MONTHS: 12,
  } as const;

export function mapSellerProductToDurationInMonths({
  sellerProduct,
}: {
  sellerProduct?: TSpendingLimitType;
}) {
  if (!sellerProduct) return null;
  return SELLER_PRODUCT_TO_DURATION_IN_MONTHS[sellerProduct];
}

export function checkHasThirtyDayAndThreeMonthLimit(
  limits: { duration: TSpendingLimitType }[],
) {
  return (
    limits.filter(
      (limit) =>
        limit.duration === 'THIRTY_DAYS' || limit.duration === 'THREE_MONTHS',
    ).length > 1
  );
}
